import { some } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isModeMatch(viewMode, test) {
  let arrModes;
  if (typeof test === 'string') {
    arrModes = [parseInt(test, 10)];
  } else if (typeof test === 'number') {
    arrModes = [test];
  } else if (Array.isArray(test)) {
    arrModes = test;
  }

  if (arrModes) {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line eqeqeq
    return some(arrModes, (mode) => viewMode == mode);
  } else if (typeof test === 'function') {
    return test(viewMode);
  } else {
    return false;
  }
}

/**
 *    takes a 'modes' prop, if a match,
 *    does renders the children.
 */
// NATIONAL PARKS: Please remove this disable and try to fix it if you're here
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Visible({ modes, children, ...props }, { viewMode }) {
  if (isModeMatch(viewMode, modes)) {
    return children;
  }
  return null;
}

Visible.contextTypes = {
  viewMode: PropTypes.number,
};

Visible.propTypes = {
  modes: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
    PropTypes.func,
  ]).isRequired,
};

/**
 *    HOC takes a 'modes' prop and renders immediate child if match
 */
export function childVisible(WrappedComponent) {
  const Enchancer = ({ modes, children, ...props }, { viewMode }) => {
    if (isModeMatch(viewMode, modes)) {
      return <WrappedComponent {...props}>{children}</WrappedComponent>;
    }
    return children;
  };

  Enchancer.contextTypes = {
    ...WrappedComponent.contextTypes,
    ...Visible.contextTypes,
  };

  Enchancer.propTypes = {
    ...WrappedComponent.propTypes,
    ...Visible.propTypes,
  };

  Enchancer.displayName = `childVisible(${getDisplayName(WrappedComponent)})`;

  return Enchancer;
}
